export interface Business {
  id: string;
}
